import { render, staticRenderFns } from "./template-table.vue?vue&type=template&id=397d9c23&scoped=true&"
import script from "./template-table.ts?vue&type=script&lang=ts&"
export * from "./template-table.ts?vue&type=script&lang=ts&"
import style0 from "./template-table.scss?vue&type=style&index=0&id=397d9c23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d9c23",
  null
  
)

export default component.exports